import axios from "axios";
import { useEffect } from "react";
import { MY_PROFILE_URL } from "shared/constants/apiUrls";
import { useCurrentCountry } from "shared/hooks/useCurrentCountry";

if (import.meta.env.VITE_APP_API_HOST !== "") {
  axios.defaults.withCredentials = true;
}

export const ComponentReviews = () => {
  useCurrentCountry();

  useEffect(() => {
    fetch(import.meta.env.VITE_APP_API_HOST + MY_PROFILE_URL, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data.uid) {
          const btn = document.querySelector(".btn-join");
          if (btn) {
            btn.innerText = "Back to site";
          }
        }
      })
      .catch((err) => {
        console.log(err.message);

        if (!err.success) {
          const btn = document.querySelector(".btn-join");
          const logo = document.querySelector(".logo_wrap");
          if (btn && logo) {
            btn.setAttribute("href", "/");
            logo.setAttribute("href", "/");
          }
        }
      });
  }, []);
};
